import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { InputAdornment, TextField, Tooltip } from '@mui/material';

export const TextFieldAdapter = ({
  input: { name, onChange, value, ...restInput },
  meta,
  tooltip,
  ...rest
}: any) => {
  const stopPropagation = (event: any) => {
    event.stopPropagation();
  };

  return (
    <TextField
      {...rest}
      {...restInput}
      name={name}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(event) => {
        stopPropagation(event);
        restInput.onKeyDown?.(event);
        rest.onKeyDown?.(event);
      }}
      onKeyUp={(event) => {
        stopPropagation(event);
        restInput.onKeyUp?.(event);
        rest.onKeyUp?.(event);
      }}
      onMouseDown={(event) => {
        stopPropagation(event);
        restInput.onMouseDown?.(event);
        rest.onMouseDown?.(event);
      }}
      onClick={(event) => {
        stopPropagation(event);
        restInput.onClick?.(event);
        rest.onClick?.(event);
      }}
      helperText={meta.touched ? meta.error : ''}
      error={meta.error && meta.touched}
      value={value ?? ''}
      fullWidth
      InputProps={{
        ...(rest.InputProps ?? {}),
        endAdornment: tooltip ? (
          <InputAdornment
            position="end"
            sx={{
              display: 'none',
              '.MuiFormLabel-root.Mui-focused ~ .MuiInputBase-root &, .MuiFormLabel-root.MuiFormLabel-filled ~ .MuiInputBase-root &':
                {
                  display: 'flex'
                }
            }}>
            <Tooltip title={tooltip} placement="top" arrow>
              <HelpOutlineIcon
                sx={{
                  fontSize: 19,
                  color: 'rgba(0, 0, 0, 0.38)',
                  cursor: 'help',
                  transition: 'color 120ms ease',

                  '&:hover': {
                    color: 'rgba(0, 0, 0, 0.65)'
                  }
                }}
              />
            </Tooltip>
          </InputAdornment>
        ) : null
      }}
    />
  );
};
